export default __webpack_public_path__ + "static/media/this-is-our-school.fe046683.png";